import { useState, useRef } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import TermsAndConditionsCheckbox from "./MonthlySubscriptionTermsCheckbox";
import { CartModel } from "atoms/models";
import { useRecoilValue } from "recoil";
import { agreedWithTcState } from "atoms";

const MonthlySubscriptionTermsModal: React.FC<{ cart: CartModel; onContinue: Function; tcServiceAgreement: any }> = ({
  cart,
  onContinue,
  tcServiceAgreement,
}) => {
  const [termsAndConditionsModal, setTermsAndConditionsModal] = useState(false);
  const htmlRef = useRef<HTMLDivElement | null>(null);
  const agreedWithTc = useRecoilValue(agreedWithTcState);
  return (
    <>
      <Button
        variant="primary"
        onClick={() => setTermsAndConditionsModal(true)}
        className={agreedWithTc ? "me-2 mb-2 monthly-subscription-terms-button-checked" : "me-2 mb-2 monthly-subscription-terms-button"}
      >
        Customer Service Agreement
      </Button>
      <Modal show={termsAndConditionsModal} onHide={() => setTermsAndConditionsModal(false)} className="monthly-subscription-terms-modal" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Customer Service Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {tcServiceAgreement !== null ? (
            <>
              <div ref={htmlRef} dangerouslySetInnerHTML={{ __html: tcServiceAgreement }} />
              <TermsAndConditionsCheckbox
                cart={cart}
                tcServiceAgreement={tcServiceAgreement}
                setTermsAndConditionsModal={setTermsAndConditionsModal}
              />
            </>
          ) : (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MonthlySubscriptionTermsModal;
